import { combineEpics, ofType } from "redux-observable";
import { EMPTY, of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { IdPersistence } from "../../constants/IdPersistence";
import { IdCountryCode } from "../../utils/i18n/IdCountryCode";
import { IdLang } from "../../utils/i18n/IdLang";
import { utilLoca } from "../../utils/i18n/utilLoca";
import { utilLoader } from "../../utils/loader/utilLoader";
import { utilPersistence } from "../../utils/utilPersistence";
import { utilVersion } from "../../utils/utilVersion";
import { TypeActionApp } from "../app/actionApp";
import { actionLocaChange } from "./actionLoca";
var epicLocaLoad = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionApp.Init), switchMap(function () {
        var _a;
        var credentials = utilPersistence.getValue(IdPersistence.Credentials, {
            country: IdCountryCode.International,
            language: IdLang.English,
        });
        var lang = utilLoca.getLangFromCountryCode(credentials.country);
        return utilLoader
            .load("i18n_" + lang, (_a = {},
            _a[lang] = process.env.PUBLIC_URL + "/i18n/" + lang + ".json?v=" + utilVersion.getCurrentVersion(),
            _a))
            .pipe(switchMap(function (loader) {
            if (loader.progress >= 100) {
                utilLoca.languageLoaded(lang, loader.resources[lang].data);
                utilLoca.swapLang(lang);
                return of(actionLocaChange(lang));
            }
            return EMPTY;
        }));
    }));
};
export var epicLoca = combineEpics(epicLocaLoad);



//////////////////
// WEBPACK FOOTER
// ./src/features/loca/epicLoca.ts
// module id = 1986
// module chunks = 3